// extracted by mini-css-extract-plugin
export default {"root":"LandingPageSlice_root__2y6hA"};